import React from 'react';
import { observer } from 'mobx-react';
import { DeckUI } from '@seedlang/state';
import ConceptDescription from './concept_description';

@observer
class CaseDescription extends React.Component {

  render() {
    const sentence = DeckUI.currentSentence;
    const selectedWordAssociationIds = DeckUI.currentCard.wordAssociationIds;
    const selectedWordAssociations = sentence?.wordAssociations.filter(wordAssociation => selectedWordAssociationIds.includes(wordAssociation.id));

    const concepts = selectedWordAssociations
      .map(wordAssociation => wordAssociation.word?.wordTypeConcept)
      .filter(concept => concept !== null && concept !== undefined);

    return (
      <>
        {
        concepts.map((concept, index) => {
          return (
          <ConceptDescription
            key={concept.id || index}
            concept={concept}
          />
          );
        })}
      </>
    );
  }
}

export default CaseDescription;
